import { UserCreate, UserPatch, UserResponse } from '@siteday/shared';
import { type z } from 'zod';

import { api } from './client';
import { listOf } from './list';

export type UsersFilters = { role?: string | undefined; active?: string | undefined };

export const listUsers = (filters: UsersFilters = {}) =>
  api.get('/users', listOf(UserResponse), { role: filters.role, active: filters.active });

export const createUser = (input: z.input<typeof UserCreate>) =>
  api.post('/users', UserCreate.parse(input), UserResponse);

export const patchUser = (id: string, patch: z.input<typeof UserPatch>) =>
  api.patch(`/users/${id}`, UserPatch.parse(patch), UserResponse);

export const deactivateUser = (id: string) =>
  api.post(`/users/${id}/deactivate`, undefined, UserResponse);

export const inviteUser = (id: string) => api.post(`/users/${id}/invite`, undefined);
